import { Component } from "react";
import {
  Typography,
  Paper,
  Container,
  IconButton,
  Box,
  Link,
  Stack,
  Button,
} from "@mui/material";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: null };
    this.target =
      window.localStorage.getItem("agent_service") === "shahrzad"
        ? "/school/parent/students"
        : "/";
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error && error.message };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box pt={10} sx={{ bgcolor: "#00C19F", minHeight: "100vh" }}>
          <Container maxWidth="sm">
            <Paper
              sx={{ px: 2, py: 4, bgcolor: "background.paper" }}
              elevation={10}
            >
              <Stack alignItems="center" spacing={3}>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: "iranYekan",
                    textAlign: "justify",
                    wordSpacing: "-3px",
                    lineHeight: "40px",
                  }}
                >
                  مشکلی پیش امده است، لطفا اطلاع دهید 🙁
                </Typography>

                <Button
                  LinkComponent={Link}
                  href={this.target}
                  sx={{ fontFamily: "iranYekan", color: "#333" }}
                >
                  برگشت به صفحه اصلی
                </Button>
              </Stack>
            </Paper>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
